import * as React from 'react';
import { FunctionComponent } from 'react';

import { Modal, Heading, Text } from 'basecamp';

import { translate } from '../../../utils/locale';

type Props = {
	setShowModal: React.Dispatch<React.SetStateAction<boolean>>;
	handleDelete: (userId: number) => void;
	userId: number;
};

const DeleteUserModal: FunctionComponent<Props> = (props) => {
	const handleDeleteClick = () => {
		props.handleDelete(props.userId);
		props.setShowModal(false);
	};

	return (
		<Modal
			setAs="small"
			close={() => props.setShowModal(false)}
			withCancelText={translate('manageUsers.modals.deleteUser.CANCEL') as string}
			withActions={[
				{
					title: translate('manageUsers.modals.deleteUser.DELETE') as string,
					onClick: handleDeleteClick,
					type: 'error',
				},
			]}
			andBodyPadY={4}
			dataTest="deleteUserModal"
		>
			<Heading setAs="large" withColor="error" dataTest="deleteUserModalTitle">
				{translate('manageUsers.modals.deleteUser.TITLE') as string}
			</Heading>
			<Text mb={3} dataTest="deleteUserModalBody">
				{translate('manageUsers.modals.deleteUser.DESCRIPTION') as string}
			</Text>
		</Modal>
	);
};

export default DeleteUserModal;
